import { create } from "zustand";

export const useGlobalAudioRecorder = create((set, get) => ({
  // --- Refs, variables ---
  chunksRef: [],
  canvasRef: { current: null },

  telehealthWS: null,
  telehealthMicStream: null,
  telehealthScreenStream: null,
  telehealthAudioContext: null,

  // --- States ---
  analyser: null,
  audioUrl: null,
  isPaused: false,
  isStopped: false,
  dataArray: null,
  audioBlob: null,
  isRecording: false,
  audioContext: null,
  audioDuration: null,
  mediaRecorder: null,
  deviceId: null,

  // Allow setting canvasRef from UI
  setCanvasRef: (ref) => set({ canvasRef: ref }),

  setIsRecording: (value) => set({ isRecording: value }),

  startRecording: async () => {
    const deviceId = get().deviceId;

    const constraints = {
      audio: deviceId ? { deviceId: { exact: deviceId } } : true
    };

    const stream = await navigator.mediaDevices.getUserMedia(constraints);

    const recorder = new MediaRecorder(stream);

    const audioContext = new AudioContext();
    const source = audioContext.createMediaStreamSource(stream);

    const analyserNode = audioContext.createAnalyser();
    analyserNode.fftSize = 256;
    const bufferLength = analyserNode.frequencyBinCount;
    const dataArray = new Uint8Array(bufferLength);
    source.connect(analyserNode);

    set({
      stream,
      analyser: analyserNode,
      dataArray,
      audioContext,
      mediaRecorder: recorder,
      isPaused: false,
      isRecording: true,
      isStopped: false,
      chunksRef: [],
    });

    recorder.ondataavailable = (event) => {
      if (event.data.size > 0) {
        get().chunksRef.push(event.data);
      }
    };

    recorder.onstop = () => {
      const blob = new Blob(get().chunksRef, { type: "audio/webm" });
      set({ audioBlob: blob });
    };

    recorder.start(1000);
  },
  
  setTelehealthData: (data) => set(data),

  stopRecording: () => {
    const { mediaRecorder, stream } = get();

    if (mediaRecorder && mediaRecorder.state !== "inactive") {
      mediaRecorder.stop();
    }

    stream?.getTracks().forEach(t => t.stop());

    set({
      stream: null,
      isRecording: false,
      isPaused: false,
      isStopped: true
    });
  },

  pauseRecording: () => {
    const { mediaRecorder, isRecording, isPaused } = get();
    if (mediaRecorder && isRecording && !isPaused) {
      mediaRecorder.pause();
      set({ isPaused: true });
    }
  },

  resumeRecording: () => {
    const { mediaRecorder, isRecording, isPaused } = get();
    if (mediaRecorder && isRecording && isPaused) {
      mediaRecorder.resume();
      set({ isPaused: false });
    }
  },

  setDeviceId: (id) => set({ deviceId: id }),

  setAudioBlob: (blob) => set({ audioBlob: blob }),
}));